import api from './api';

/**
 * Busca todas as requisições de um paciente
 * @param {number} codPac - Código do paciente
 * @returns {Promise<Array>} Lista de requisições
 */
export const getRequisicoesPaciente = async (codPac) => {
  const { data } = await api.get(`paciente/${codPac}/requisicoes`);
  return data;
};

/**
 * Busca uma requisição específica por ID
 * @param {number} codRequisicao - Código da requisição
 * @returns {Promise<Object>} Dados da requisição
 */
export const getRequisicaoById = async (codRequisicao) => {
  const { data } = await api.get(`requisicao/${codRequisicao}`);
  return data;
};

/**
 * Cria uma nova requisição de exames
 * @param {Object} payload - Dados da requisição
 * @param {number} payload.codConsulta - Código da consulta
 * @param {number} payload.codMedico - Código do médico
 * @param {number} payload.codPaciente - Código do paciente
 * @param {string} payload.descricao - Texto da requisição
 * @param {string} [payload.status='ONLINE'] - Status da requisição
 * @returns {Promise<Object>} Requisição criada
 */
export const createRequisicao = async (payload) => {
  const { data } = await api.post('requisicao/', payload);
  return data;
};

/**
 * Atualiza uma requisição existente
 * @param {number} codRequisicao - Código da requisição
 * @param {Object} payload - Dados para atualização
 * @param {string} payload.descricao - Texto atualizado da requisição
 * @param {string} [payload.tipo] - Tipo da requisição
 * @param {string} [payload.gravacao] - PARCIAL ou DEFINITIVO
 * @returns {Promise<Object>} Resultado da atualização
 */
export const updateRequisicao = async (codRequisicao, payload) => {
  const { data } = await api.put(`requisicao/${codRequisicao}`, payload);
  return data;
};

export const deleteRequisicao = async (codRequisicao) => {
  const { data } = await api.delete(`requisicao/${codRequisicao}`);
  return data;
};
